import type { Observable as ObservableType } from 'rxjs/Observable';
import { mutation$ } from '@atlassian/jira-software-swag/src/services/mutation/index.tsx';

const MUTATION_NAME = 'BacklogDeleteSprint';

export const getMutation = (boardId: string, sprintId: string) =>
	`mutation ${MUTATION_NAME} {
        deleteSprint(input: { boardId: ${boardId}, sprintId: ${sprintId} }) {
            success
        }
    }`;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: string, sprintId: string, boardId: string): ObservableType<void> =>
	mutation$<undefined>(baseUrl, MUTATION_NAME, getMutation(boardId, sprintId));
